import { InstallParameters } from './index';
import { QueuedAttempts } from '@/app/tools/QueuedAttempts';
import { iMetricsSender } from '@/app/modules/Metrics/types';

type MetrikaPacket = Record<string, Record<string, any> | any>;

export default class Loader implements iMetricsSender {
    /**
     * Делаем 20 попыток загрузки, каждые 100 мс
     */
    protected readonly AttemptsManager = new QueuedAttempts<MetrikaPacket>(
        30,
        150,
        'YMetrique'
    );

    /**
     * Yandex metrika instance object
     */
    protected metrikaInstance?: any;

    /**
     * Запускаем метрику, сразу после установки можем выполнить callback
     *
     * @param bootstrap_parameters
     */
    public bootstrap(bootstrap_parameters: InstallParameters): Promise<void> {
        return this.AttemptsManager.makeLoop(
            /* istanbul ignore next */
            () => window.Ya && typeof window.Ya.Metrika === 'function'
        ).then(() => {
            this.metrikaInstance = new window.Ya.Metrika(
                bootstrap_parameters.metrikaConfig
            );
            if (typeof bootstrap_parameters.afterInstall === 'function') {
                bootstrap_parameters.afterInstall();
            }
            // Раскручиваем очередь
            this.AttemptsManager.getQueue().forEach((item: MetrikaPacket) =>
                this.send(item)
            );
        });
    }

    /**
     * Отправляем параметры
     *
     * @param send_parameters
     */
    public send(send_parameters: MetrikaPacket) {
        if (this.AttemptsManager.getIsInstalled()) {
            log('Metrika', null, send_parameters);
            this.metrikaInstance.params(send_parameters);
        } else {
            this.AttemptsManager.addToQueue(send_parameters);
        }
    }

    /**
     * Получаем Yandex client id ПОСЛЕ УСТАНОВКИ метрики
     */
    public getClientID(): string | null {
        if (this.AttemptsManager.getIsInstalled()) {
            return this.metrikaInstance.getClientID();
        } else {
            return null;
        }
    }

    /**
     * Получаем Yandex metrika instance object
     */
    public getMetrikaInstance() {
        return this.metrikaInstance;
    }
}

function log(title: string, label: string | null, data: object) {
    if (process.env.VUE_APP_ENVIRONMENT !== 'production') {
        // немного dev-only извращений
        let maxLength = 0;

        console.groupCollapsed(
            `%c ${title} %c`,
            `font-weight: bold; background: #1030ce; color: white; padding: 1px; border-radius: 3px`,
            'background: transparent',
            label || ''
        );

        Object.entries(data)
            .sort((a, b) => a[0].localeCompare(b[0], 'en-EN-u-kn'))
            .map(([key, value]) => {
                if (key.length > maxLength) {
                    maxLength = ('' + key).length;
                }

                return [key, value];
            })
            .forEach(([key, value]) => {
                const spaces = new Array(maxLength - key.length)
                    .fill(Number)
                    .map(() => ' ')
                    .join('');

                console.log(
                    `${key} ${spaces} %c${
                        typeof value === 'object'
                            ? JSON.stringify(value)
                            : value
                    }`,
                    'color: blue'
                );
            });

        console.groupEnd();
    }
}
